<div class="row">
    <div class="col-4 mt-2">
        <div class="card">
            <div class="card-header">
                <h5>A2P Registration Status</h5>
            </div>
            <div class="card-body">
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between">
                        <div class="d-flex flex-column">
                            <strong>Customer Profile</strong>
                            <small class="text-muted">Updated on {{subAccountDetails?.customerProfile.updatedAt | date:'longDate':'UTC'}}</small>
                        </div>
                        <ng-container [ngTemplateOutlet]="reviewStatus" [ngTemplateOutletContext]="{ reviewStatus: subAccountDetails?.customerProfile.reviewStatus }"></ng-container>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                        <div class="d-flex flex-column">
                            <strong>Trust Product</strong>
                            <small class="text-muted">Updated on {{subAccountDetails?.trustProduct.updatedAt | date:'longDate':'UTC'}}</small>
                        </div>
                        <ng-container [ngTemplateOutlet]="reviewStatus" [ngTemplateOutletContext]="{ reviewStatus: subAccountDetails?.trustProduct.reviewStatus }"></ng-container>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                        <div class="d-flex flex-column">
                            <strong>Brand Registration</strong>
                            <small class="text-muted">Updated on {{subAccountDetails?.brandRegistration.updatedAt | date:'longDate':'UTC'}}</small>
                        </div>
                        <ng-container [ngTemplateOutlet]="brandRegistrationStatus" [ngTemplateOutletContext]="{ status: subAccountDetails?.brandRegistration.status }"></ng-container>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-8 mt-2">
        <div class="card">
            <div class="card-header">
                <div class="d-flex w-100">
                    <h5 class="my-auto">Messaging Services</h5>
                    <button type="button" class="btn ms-auto my-auto" [class.btn-primary]="isMessagingServiceActive" [class.btn-danger]="!isMessagingServiceActive" (click)="toggleMessagingService();">
                        <fa-icon [icon]="isMessagingServiceActive ? faToggleOn : faToggleOff"></fa-icon>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="d-flex flex-column">
                    <div class="d-flex border-bottom">
                        <h5>Conversation Campaign</h5>
                        @if (subAccountDetails?.messagingService) { <small class="text-muted ms-auto">Updated on {{subAccountDetails?.messagingService?.conversationCampaign.updatedAt | date:'longDate':'UTC'}}</small> }
                    </div>
                    <div class="row">
                        <div class="col-auto mt-2">
                            <strong>Status</strong>
                            @if (subAccountDetails?.messagingService) {
                            <ng-container [ngTemplateOutlet]="conversationCampaignStatus" [ngTemplateOutletContext]="{ status: subAccountDetails?.messagingService.conversationCampaign.status }"></ng-container>
                            } @else {
                            <div class="d-flex text-secondary my-auto">
                                <p class="mb-0">Not Configured</p>
                                <fa-icon [icon]="faQuestionCircle" class="ms-2"></fa-icon>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #reviewStatus let-reviewStatus="reviewStatus">
    @switch(reviewStatus) {
    @case("draft") {
    <div class="d-flex text-secondary my-auto">
        <p class="mb-0">Draft</p>
        <fa-icon [icon]="faClock" class="ms-2"></fa-icon>
    </div>
    }
    @case("pending-review") {
    <div class="d-flex text-secondary my-auto">
        <p class="mb-0">Waiting for Review</p>
        <fa-icon [icon]="faClock" class="ms-2"></fa-icon>
    </div>
    }
    @case("in-review") {
    <div class="d-flex text-secondary my-auto">
        <p class="mb-0">In Review</p>
        <fa-icon [icon]="faClock" class="ms-2"></fa-icon>
    </div>
    }
    @case("twilio-rejected") {
    <div class="d-flex text-danger my-auto">
        <p class="mb-0">Rejected</p>
        <fa-icon [icon]="faXmarkCircle" class="ms-2"></fa-icon>
    </div>
    }
    @case("twilio-approved") {
    <div class="d-flex text-success my-auto">
        <p class="mb-0">Approved</p>
        <fa-icon [icon]="faCheckCircle" class="ms-2"></fa-icon>
    </div>
    }
    @default {
    <div class="d-flex text-secondary my-auto">
        <p class="mb-0">Unknown</p>
        <fa-icon [icon]="faQuestionCircle" class="ms-2"></fa-icon>
    </div>
    }
    }
</ng-template>

<ng-template #brandRegistrationStatus let-status="status">
    @switch(status) {
    @case("PENDING") {
    <div class="d-flex text-secondary my-auto">
        <p class="mb-0">Pending</p>
        <fa-icon [icon]="faClock" class="ms-2"></fa-icon>
    </div>
    }
    @case("IN_REVIEW") {
    <div class="d-flex text-secondary my-auto">
        <p class="mb-0">In Review</p>
        <fa-icon [icon]="faClock" class="ms-2"></fa-icon>
    </div>
    }
    @case("FAILED") {
    <div class="d-flex text-danger my-auto">
        <p class="mb-0">Failed</p>
        <fa-icon [icon]="faXmarkCircle" class="ms-2"></fa-icon>
    </div>
    }
    @case("APPROVED") {
    <div class="d-flex text-success my-auto">
        <p class="mb-0">Approved</p>
        <fa-icon [icon]="faCheckCircle" class="ms-2"></fa-icon>
    </div>
    }
    @case("SUSPENDED") {
    <div class="d-flex text-warning my-auto">
        <p class="mb-0">Suspended</p>
        <fa-icon [icon]="faExclamationCircle" class="ms-2"></fa-icon>
    </div>
    }
    @default {
    <div class="d-flex text-secondary my-auto">
        <p class="mb-0">Unknown</p>
        <fa-icon [icon]="faQuestionCircle" class="ms-2"></fa-icon>
    </div>
    }
    }
</ng-template>

<ng-template #conversationCampaignStatus let-status="status">
    @switch(status) {
    @case("PENDING") {
    <div class="d-flex text-secondary my-auto">
        <p class="mb-0">Pending</p>
        <fa-icon [icon]="faClock" class="ms-2"></fa-icon>
    </div>
    }
    @case("IN_PROGRESS") {
    <div class="d-flex text-secondary my-auto">
        <p class="mb-0">In Review</p>
        <fa-icon [icon]="faClock" class="ms-2"></fa-icon>
    </div>
    }
    @case("FAILED") {
    <div class="d-flex text-danger my-auto">
        <p class="mb-0">Failed</p>
        <fa-icon [icon]="faXmarkCircle" class="ms-2"></fa-icon>
    </div>
    }
    @case("VERIFIED") {
    <div class="d-flex text-success my-auto">
        <p class="mb-0">Verified</p>
        <fa-icon [icon]="faCheckCircle" class="ms-2"></fa-icon>
    </div>
    }
    @default {
    <div class="d-flex text-secondary my-auto">
        <p class="mb-0">Unknown</p>
        <fa-icon [icon]="faQuestionCircle" class="ms-2"></fa-icon>
    </div>
    }
    }
</ng-template>